module.exports = __webpack_public_path__ + "img/T1_ty_0.9d20d7de.png";